import { isNull, isObject, isUndefined } from 'lodash-es';
import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';
import { MenuStructure, useMenuProvider } from '../../composables';

export const useAppStore = defineStore('appStore', () => {
    const ready = ref(false);
    const language = ref<string>(document.documentElement.lang || 'no');
    const lastKnownError = ref<Error | null>(null);

    const config = reactive({
        kolumbusWebsiteBaseUrl: '',
        supportedLanguages: ['no', 'en']
    });
    const menuItems = ref<MenuStructure>({ baseUrl: '/' });

    async function init(options: { kolumbusWebsiteBaseUrl: string }) {
        // set default config values
        config.kolumbusWebsiteBaseUrl = options.kolumbusWebsiteBaseUrl;

        // load menu items
        await loadMenuItems();
    }

    function registerError(error: any) {
        lastKnownError.value = isErrorWithMessage(error) ? error : new Error(String(error));
    }

    async function loadMenuItems() {
        try {
            // fetch from kolumbus website
            const menuProvider = useMenuProvider(config.kolumbusWebsiteBaseUrl);

            // set menu items
            menuItems.value = await menuProvider.getMenuItems();

            // set up supported languages
            config.supportedLanguages = menuItems.value.supportedLanguages?.map(l => l.code) || [];
        } catch (error) {
            console.error('Error loading menu items', error);
        }
    }

    return {
        config,
        ready,
        language,
        lastKnownError,
        menuItems,
        init,
        registerError
    };
});

function isErrorWithMessage(error: unknown): error is Error {
    return !isUndefined(error) && !isNull(error) && isObject(error) && 'message' in error && typeof error.message === 'string';
}
